const contactInformation = {
  email: 'portal@go-e.com',
};

export default contactInformation;
